var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"type":"submit","color":"secondary","depressed":"","disabled":!_vm.valid || _vm.loading,"loading":_vm.loading,"form":_vm.form},on:{"click":function($event){$event.preventDefault();return _vm.submit()}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("done")]),_vm._v("Submit ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }